import React from 'react';
import {Route, Switch} from 'react-router-dom';
import CompaniesPanel from './company/CompaniesPanel';
import EditCompanyPage from './company/EditCompanyPage';
import EditTeamPage from './teams/EditTeamPage';
import ProgramPage from './program/ProgramPage';
import EditProgramPage from './program/EditProgramPage';
import CompanyPage from './company/CompanyPage';
import TeamPage from './teams/TeamPage';
import EditContactPage from './contacts/EditContactPage';
import ContactsPage from './contacts/ContactsPage';
import ContactPage from './contacts/ContactPage';
import Login from './user/Login';
import EditUserPage from './user/EditUserPage';
import VerifyPage from './user/VerifyPage';
import PropTypes from 'prop-types';
import Authorization from './user/Authorization';
import {Col, Grid, Row} from 'react-bootstrap';
import UserList from './user/UserList';
import NotFoundPage from './NotFoundPage';
import CoachReportPage from './teams/CoachReportPage';
import GenerateGroupAssessment from './teams/GenerateGroupAssessment';
import CoachAssessment from './teams/CoachAssessment';
import GroupAssessment from './teams/GroupAssessment';
import GroupReportPage from './teams/GroupReportPage';
import ForgotPassword from './user/ForgotPassword';
import ResetPassword from './user/ResetPassword';
import ForceChangePassword from './user/ForceChangePassword';
import {UserContext} from './user/user-context';
import InviteUser from './user/InviteUser';
import EditAssessment from './assessments/assessment-form/EditAssessment';
import EditAssessmentQuestion from './assessments/assessment-form/EditAssessmentQuestion';
import AssessmentsPage from './assessments/AssessmentsPage';
import EngagementPage from './engagement/EngagementPage';
import CreateEngagementPage from './engagement/CreateEngagementPage';

const Customer = Authorization(['customer', 'coach', 'admin']);
const Coach = Authorization(['coach', 'admin']);
const Admin = Authorization(['admin']);

const AuthCompaniesPanel  = Customer(CompaniesPanel);
const AuthCompanyPage     = Customer(CompanyPage);
const AuthEditCompany     = Admin(EditCompanyPage);
const AuthContacts        = Customer(ContactsPage);
const AuthContactPage     = Customer(ContactPage);
const AuthEditContact     = Customer(EditContactPage);
const AuthProgramPage     = Customer(ProgramPage);
const AuthEditProgram     = Coach(EditProgramPage);
const AuthEditTeam        = Coach(EditTeamPage);
const AuthTeamPage        = Customer(TeamPage);
const AuthCoachAssessment = Customer(CoachAssessment);
const AuthReport          = Customer(CoachReportPage);
const AuthEditUser        = Admin(EditUserPage);
const AuthUserList        = Admin(UserList);
const AuthNotFound        = Customer(NotFoundPage);
const AuthGenGrpAsmt      = Coach(GenerateGroupAssessment);
const AuthGroupReport     = Coach(GroupReportPage);
const AuthInviteUser      = Admin(InviteUser);
const AuthCreateAssessment= Admin(EditAssessment);
const AuthAddAsmtQuestion = Admin(EditAssessmentQuestion);
const AuthAssessmentsPage = Admin(AssessmentsPage);
const AuthEngagementPage  = Customer(EngagementPage);
const AuthCreateEngagement= Customer(CreateEngagementPage);

class Routes extends React.Component {
  render() {
    const authProps = this.props.childProps;
    return (
      <main>
        <Grid>
          <Row>
            <Col xs={12}>
              <Switch>
                <Route path='/companies/:companyId/programs/:programId/teams/create' render={(props) => <AuthEditTeam {...props} auth={authProps} />}/>
                <Route path='/companies/:companyId/programs/:programId/teams/:teamId/report' render={(props) => <AuthReport {...props} auth={authProps} />}/>
                <Route path='/companies/:companyId/programs/:programId/teams/:teamId/selfreports/:groupAssessmentId' render={(props) => <AuthGroupReport {...props} auth={authProps} />}/>
                <Route path='/companies/:companyId/programs/:programId/teams/:teamId/reports/:teamAssessmentId' render={(props) => <AuthReport {...props} auth={authProps} />}/>
                <Route path='/companies/:companyId/programs/:programId/teams/:teamId/assessment' render={(props) => <AuthCoachAssessment {...props} auth={authProps} />}/>
                <Route path='/companies/:companyId/programs/:programId/teams/:teamId/selfassessment/create' render={(props) => <AuthGenGrpAsmt {...props} auth={authProps}/>}/>
                <Route path='/companies/:companyId/programs/:programId/teams/:teamId/edit' render={(props) => <AuthEditTeam {...props} auth={authProps} />}/>
                <Route path='/companies/:companyId/programs/:programId/teams/:teamId' render={(props) => <AuthTeamPage {...props} auth={authProps} />}/>
                <Route path='/companies/:companyId/programs/:programId/edit' render={(props) => <AuthEditProgram {...props} auth={authProps} />}/>
                <Route path='/companies/:companyId/programs/create/' render={(props) => <AuthEditProgram {...props} auth={authProps} />}/>
                <Route path='/companies/:companyId/programs/:programId' render={(props) => <AuthProgramPage {...props} auth={authProps} />}/>
                <Route path='/companies/:companyId/contacts/:contactId/edit' render={(props) => <AuthEditContact {...props} auth={authProps} />}/>
                <Route path='/companies/:companyId/contacts/:contactId' render={(props) => <AuthContactPage {...props} auth={authProps} />}/>
                <Route path='/companies/:companyId/contacts/' render={(props) => <AuthContacts {...props} auth={authProps} />}/>
                <Route path='/companies/:companyId/engagements/create' render={(props) => <AuthCreateEngagement {...props} auth={authProps} />}/>
                <Route path='/companies/:companyId/engagements/:engagementId' render={(props) => <AuthEngagementPage {...props} auth={authProps} />}/>
                <Route path='/companies/:id/edit' render={(props) => <AuthEditCompany {...props} auth={authProps} />}/>
                <Route path='/companies/create' exact render={(props) => <AuthEditCompany {...props} auth={authProps}/>}/>
                <Route path='/companies/:companyId' render={(props) => <AuthCompanyPage {...props} auth={authProps} />}/>
                <Route path='/companies' exact render={(props) => <AuthCompaniesPanel {...props} auth={authProps} />}/>
                <Route path='/assessments/create' exact render={(props) => <AuthCreateAssessment {...props} auth={authProps}/>}/>
                <Route path='/assessments/create/add-question/:subId' exact render={(props) => <AuthAddAsmtQuestion {...props} auth={authProps}/>}/>
                <Route path='/assessments/create/edit-question/:subId/:qId' exact render={(props) => <AuthAddAsmtQuestion {...props} auth={authProps}/>}/>
                <Route path='/assessments' exact render={(props) => <AuthAssessmentsPage {...props} auth={authProps}/>}/>
                <Route path='/surveys' component={GroupAssessment}/>
                <Route path='/verify' exact component={VerifyPage}/>
                <Route path='/forgot' exact component={ForgotPassword}/>
                <Route path='/reset' exact component={ResetPassword}/>
                <Route path='/force-password' exact render={(props) => <UserContext.Consumer>{ context => <ForceChangePassword {...props} user={context.user} auth={authProps}/> }</UserContext.Consumer> }/>
                <Route path='/login' exact render={() => <Login auth={authProps}/>}/>
                <Route path='/users' exact render={(props) => <AuthUserList {...props} auth={authProps} />}/>
                <Route path='/users/invite' exact render={(props) => <AuthInviteUser {...props} auth={authProps} />}/>
                <Route path='/users/edit' exact render={(props) => <AuthEditUser {...props} auth={authProps} />}/>
                <Route path='/users/create' exact render={(props) => <AuthEditUser {...props} auth={authProps} />}/>
                <Route path='/' exact render={(props) => <AuthCompaniesPanel {...props} auth={authProps} />}/>
                <Route render={(props) => <AuthNotFound {...props} auth={authProps} />}/>
              </Switch>
            </Col>
          </Row>
        </Grid>

      </main>
    );
  }
}

Routes.propTypes = {
  childProps: PropTypes.shape({
    isAuthenticated: PropTypes.bool,
    userHasAuthenticated: PropTypes.func
  })
};

export default Routes;



// WEBPACK FOOTER //
// ./src/components/Routes.js